import { c as _c } from "react-compiler-runtime";
import { createContext, useContext, useRef } from 'react';
import { Provider } from 'react-redux';
import { CellSelectionStoreContext } from '../../redux/cellSelectionStoreContext';
import { cellSelectionDisabled, isCellSelectionEnabled } from '../config';
import { jsx as _jsx } from "react/jsx-runtime";
const CellSelectionConfigContext = /*#__PURE__*/createContext(cellSelectionDisabled);
export const useIsCellSelectionEnabled = () => {
  const $ = _c(2);
  const t0 = useContext(CellSelectionConfigContext);
  let t1;
  if ($[0] !== t0) {
    t1 = isCellSelectionEnabled(t0);
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export const useCellSelectionConfig = () => {
  return useContext(CellSelectionConfigContext);
};
const CellSelectionScopeContext = /*#__PURE__*/createContext('');
export const useCellSelectionScopeId = () => {
  return useContext(CellSelectionScopeContext);
};

// The staging-aware copy routine, published by CellSelectionEffects (which owns
// the staging DOM) so the floating action menu's Copy button can run the exact
// same code path as Cmd/Ctrl+C. Held in a mutable ref rather than context value
// so publishing it doesn't re-render consumers; readers call `.current()`.
const CopySelectionRefContext = /*#__PURE__*/createContext({
  current: null
});
export const useCopySelectionRef = () => {
  return useContext(CopySelectionRefContext);
};
export const ProvideCellSelection = t0 => {
  const $ = _c(11);
  const {
    config,
    store,
    scopeId,
    children
  } = t0;
  const copySelectionRef = useRef(null);
  let t1;
  if ($[0] !== children) {
    t1 = /*#__PURE__*/_jsx(CopySelectionRefContext.Provider, {
      value: copySelectionRef,
      children: children
    });
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== scopeId || $[3] !== t1) {
    t2 = /*#__PURE__*/_jsx(CellSelectionScopeContext.Provider, {
      value: scopeId,
      children: t1
    });
    $[2] = scopeId;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== config || $[6] !== t2) {
    t3 = /*#__PURE__*/_jsx(CellSelectionConfigContext.Provider, {
      value: config,
      children: t2
    });
    $[5] = config;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== store || $[9] !== t3) {
    t4 = /*#__PURE__*/_jsx(Provider, {
      store: store,
      context: CellSelectionStoreContext,
      children: t3
    });
    $[8] = store;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};